(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-scroll-showcase"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.nx-scroll-showcase');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || !sections.length) {
      return;
    }

    const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
    const ease = value => value * value * (3 - 2 * value);
    let ticking = false;

    sections.forEach(section => {
      const frameUrls = JSON.parse(section.dataset.frameUrls || '[]');
      section._nxFrames = frameUrls;
      section._nxFrameIndex = -1;
      frameUrls.forEach(url => {
        const image = new Image();
        image.src = url;
      });
    });

    const update = () => {
      sections.forEach(section => {
        const image = section.querySelector('.nx-scroll-showcase__image');
        const copy = section.querySelector('.nx-scroll-showcase__copy');
        const depth = section.querySelector('.nx-scroll-showcase__depth');
        const rect = section.getBoundingClientRect();
        const distance = Math.max(1, rect.height - window.innerHeight);
        const progress = clamp(-rect.top / distance, 0, 1);
        const intro = ease(clamp(progress / 0.45, 0, 1));
        const outro = ease(clamp((progress - 0.62) / 0.38, 0, 1));
        const frameUrls = section._nxFrames || [];
        const frameIndex = frameUrls.length ? Math.round(progress * (frameUrls.length - 1)) : -1;
        const scale = 0.76 + intro * 0.5 - outro * 0.12;
        const y = 9 - intro * 13 + outro * 5;
        const copyOpacity = clamp(1 - progress / 0.36, 0, 1);

        if (frameIndex > -1 && frameIndex !== section._nxFrameIndex) {
          image.src = frameUrls[frameIndex];
          section._nxFrameIndex = frameIndex;
        }

        image.style.transform = `translate3d(0, ${y.toFixed(2)}vh, 0) scale(${scale.toFixed(4)})`;
        image.style.opacity = String(1 - outro * 0.08);
        copy.style.opacity = String(copyOpacity);
        copy.style.transform = `translate3d(0, ${((1 - copyOpacity) * -5).toFixed(2)}vh, 0)`;

        if (depth) {
          depth.style.transform = `translate3d(0, ${(-intro * 4 + outro * 3).toFixed(2)}vh, 0) scale(${(1 + intro * 0.08).toFixed(4)})`;
        }
      });

      ticking = false;
    };

    const requestUpdate = () => {
      if (ticking) {
        return;
      }

      ticking = true;
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    update();
  })();

  } catch(e) { console.error(e); }
})();
})();
